module.exports = __webpack_public_path__ + "img/livinglab-extended.73ed9914.svg";